// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLightNone_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 15H19L19 9H21V15ZM10 24V26H4V24H10ZM30 24H36V26H30V24ZM19 35 19 41H21V35H19ZM7.9791 35.6073 9.39331 37.0215 13.636 32.7788 12.2217 31.3646 7.9791 35.6073ZM27.7781 18.6367 26.3639 17.2225 30.6065 12.9799 32.0207 14.3941 27.7781 18.6367ZM9.39371 12.9803 7.97949 14.3945 12.2221 18.6372 13.6363 17.223 9.39371 12.9803ZM26.3643 32.7793 27.7785 31.3651 32.0211 35.6077 30.6069 37.0219 26.3643 32.7793Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M28 25C28 29.4183 24.4183 33 20 33C15.5817 33 12 29.4183 12 25C12 20.5817 15.5817 17 20 17C24.4183 17 28 20.5817 28 25ZM26 25C26 28.3137 23.3137 31 20 31C16.6863 31 14 28.3137 14 25C14 21.6863 16.6863 19 20 19C23.3137 19 26 21.6863 26 25Z" class="svg-bg"/>
  <path d="M35 7H31V9H35V7ZM37 7H41V9H37V7ZM43 7H47V9H43V7Z" fill="#828D9E"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M25 23H23V15H25V23ZM25 51V59H23V51H25Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M36 37C36 43.6274 30.6274 49 24 49C17.3726 49 12 43.6274 12 37C12 30.3726 17.3726 25 24 25C30.6274 25 36 30.3726 36 37ZM34 37C34 42.5228 29.5228 47 24 47C18.4772 47 14 42.5228 14 37C14 31.4772 18.4772 27 24 27C29.5228 27 34 31.4772 34 37Z" class="svg-bg"/>
  <path d="M33.1924 26.3932 34.6066 27.8074 40.2635 22.1505 38.8492 20.7363 33.1924 26.3932ZM7.73657 51.8502 9.15079 53.2644 14.8076 47.6076 13.3934 46.1934 7.73657 51.8502ZM7.73672 22.1511 9.15094 20.7369 14.8078 26.3938 13.3936 27.808 7.73672 22.1511ZM34.608 46.194 33.1938 47.6082 38.8506 53.265 40.2648 51.8508 34.608 46.194ZM2 38V36H10L10 38 2 38ZM38 38.0002V36.0002L46 36.0002V38.0002H38Z" class="svg-bg"/>
  <path d="M43 13H37V16H43V13ZM46 13H52V16H46V13ZM55 13H61V16H55V13Z" fill="#828D9E"/>
</svg>
`;
/**
 * IconMedLightNone is a generated icon component.
 */
let IconMedLightNone = IconMedLightNone_1 = class IconMedLightNone extends IconBaseElement {
    render() {
        return html `${IconMedLightNone_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLightNone.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedLightNone = IconMedLightNone_1 = __decorate([
    customElement('zui-icon-med-light-none')
], IconMedLightNone);
export { IconMedLightNone };
